import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Renderer2 } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SmsProgramarCobroComponent } from 'app/modals/cartera/sms-programar-cobro/sms-programar-cobro.component';
import { LlamadasComponent } from 'app/modals/cartera/llamadas/llamadas.component';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { HistorialCobrosComponent } from 'app/modals/cartera/historial-cobros/historial-cobros.component';
import { VerCobroComponent } from 'app/modals/cartera/ver-cobro/ver-cobro.component';
import { TotalServiciosGrupoComponent } from 'app/modals/cartera/total-servicios-grupo/total-servicios-grupo.component';
import { BitacoraGrupoComponent } from 'app/modals/cartera/bitacora-grupo/bitacora-grupo.component';
import { HistoricoFacturasComponent } from 'app/modals/cartera/historico-facturas/historico-facturas.component';
import { LlamadasBitacoraComponent } from 'app/modals/cartera/llamadas-bitacora/llamadas-bitacora.component';
import { BitacoraRetirosComponent } from 'app/modals/cartera/bitacora-retiros/bitacora-retiros.component';
import { FacturasAtrasadasComponent } from 'app/modals/cartera/facturas-atrasadas/facturas-atrasadas.component';
import { TipoFacturaComponent } from 'app/modals/cartera/tipo-factura/tipo-factura.component';
import { ObservacionCarteraGrupoComponent } from 'app/modals/cartera/observacion-cartera-grupo/observacion-cartera-grupo.component';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { Title } from '@angular/platform-browser';
import { BeneficiariosXGrupoComponent } from 'app/modals/cartera/beneficiarios-x-grupo/beneficiarios-x-grupo.component';

@Component({
  selector: 'app-registrar-cobro-fijo',
  templateUrl: './registrar-cobro-fijo.component.html',
  styleUrls: ['./registrar-cobro-fijo.component.scss']
})
export class RegistrarCobroFijoComponent implements OnInit, AfterViewInit, OnDestroy {

  // Variable DataTable //
  public dtOptions: any;
  public tableOpt = [];
  @ViewChild(DataTableDirective, {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();

  public ciclo: string;
  listenGlobal: Function;

  /**
   * Constructor
   * 
   * @param {CarteraService} _cartera 
   * @param {MatDialog} _dialog 
   * @param {Router} router 
   * @param {Renderer2} _renderer 
   * @param {MatSnackBar} _snackBar 
   * @param {Title} _title 
   */
  constructor
  (
    private _cartera: CarteraService,
    private _dialog: MatDialog,
    private router: Router,
    private _renderer: Renderer2,
    private _snackBar: MatSnackBar,
    private _title: Title
  ) 
  {
    this._title.setTitle('VitalSoft - Registrar Cobro Fijo');

    this.dtTrigger.next();
    this.dtOptions = {
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      autoWidth: false,
      responsive: true, 
      order: [3, 'desc'],
      columns: [
        {},
        {
          data: 'empresa'
        },
        {
          render: (data, row, type, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {
          data: 'dia_cobro'
        },
        {
          data: 'dias_antelacion'
        },
        {
          render: (data, row, type, meta) => {
            return  `<a>${data}</a>`;
          }
        },
        {
          data: 'radicado_grupo'
        },
        {
          render: (data, row, type, meta) => {
            return `<a style="color: ${data !== '0' ? '#000000' : '#FFFFFF'}">${data}</a>`;
          }
        },
        {},
        {
          data: 'ciclo_grupo'
        },
        {
          render: (data, row, type, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {
          data: 'facturas'
        },
        {
          data: 'saldo_total'
        },
        {
          data: 'total_llamadas'
        },
        {
          data: 'retiros'
        },
        {
          data: 'retraso_pagos'
        }
      ]
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.busquedaxCiclos();
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
    this.listenGlobal =  this._renderer.listen('document', 'click', (e) => {
      if(e.target.hasAttribute('llamadas')){
        let index: string = e.target.getAttribute('llamadas');
        this.modalHistoriaLlamadas(this.tableOpt[index].ID_Grupo);
      }else if(e.target.hasAttribute('retiros')){
        let index: string = e.target.getAttribute('retiros');
        let data= {
          empresa: this.tableOpt[index].empresa,
          radicado: this.tableOpt[index].radicado_grupo,
          documento: this.tableOpt[index].documento_grupo,
          nombre: this.tableOpt[index].nombre_grupo,
          retiros: this.tableOpt[index].retiros,
        }
        this.modalBitacoraRetiros(data.empresa, data.radicado, data.documento, data.nombre, data.retiros);
      }else if(e.target.hasAttribute('atrasos')){
        let index: string = e.target.getAttribute('atrasos');
        let data = {
          empresa: this.tableOpt[index].empresa,
          documento: this.tableOpt[index].documento_grupo,
          radicado: this.tableOpt[index].radicado_grupo,
          nombre: this.tableOpt[index].nombre_grupo,
          atrasos: this.tableOpt[index].retraso_pagos
        }
        this.modalFacturasAtrasadas(data.empresa, data.documento, data.radicado, data.nombre, data.atrasos);
      }
    });
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.listenGlobal();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

  /**
   * Función encargada de filtrar los grupos de acuerdo al ciclo
   * @param {string} ciclo 
   */
  public busquedaxCiclos(ciclo?: string){
    this._cartera.verGruposxCobrosFijos(ciclo).subscribe((data: Array<Object>) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * Enruta al calendario, para su respectiva asignación del cobro
   * @param {string} empresa
   * @param {string} radicado
   */
  public opcionAgendarCobro(empresa: string, radicado: string): void {
    this.router.navigate(
                          ['cobranza/cartera/cobros-fijos/agenda-calendario', 
                            'fijos', 
                            empresa === 'VitalMascotas'? '2' : '1', 
                            empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft', 
                            radicado
                          ]
                        );
  }

  /**
   * Abre el modal Historial Cobros, encargado de mostrar el historial de cobros del grupo en cuestión
   * @param {string} grunit 
   * @param {string} grugru 
   */
  public opcionHistorialCobros(grunit: string, grugru: string): void{
    this._dialog.open(HistorialCobrosComponent, {
      maxWidth: '93vw',
      data: {
        grunit: grunit,
        grugru: grugru,
      }
    });
  }

  /**
   * Abre el modal Llamada, encargado de registrar una llamada al grupo anteriormente consultado,
   * al cerrarse y si devuelve una variable verdadera, ejecuta 'mostrarInfoGrupo'
   * 
   * @param {string} empresa 
   * @param {string} radicado 
   * @param {number} index 
   */
  public opcionLlamadas(empresa: string, radicado: string, index: number): void {
    const hora_actual: any = moment();
    let modal;
    modal = this._dialog.open(LlamadasComponent, {
      width: '63%',
      height: '100%',
      panelClass: 'custom-dialog-container',
      data: {
        data_base: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft',
        indice: empresa === 'VitalMascotas'? '2' : '1',
        grunit: this.tableOpt[index].documento_grupo,
        grugru: radicado,
        hora: hora_actual.format('HH:mm:ss'),
        search_code: radicado,
        origen: 'fijos'
      }
    }); 

    modal.afterClosed().subscribe((result: boolean) => {
      if(result) this.busquedaxCiclos(this.ciclo);
    });
  }

  /**
   * esta funcion abre el modal de sms de programar cobros y 
   * manda por parametros los datos (numero,telefono,radicado,grupo,factura) del radicado
   * mostrado en la tabla
   * 
   * @param {string} empresa 
   * @param {string} radicado 
   * @param {number} index 
   */
  public opcionSMS(empresa: string, radicado: string, index: number): void {
    if(empresa === 'VitalMascotas'){
      return;
    }
    this._dialog.open(SmsProgramarCobroComponent,{
      width:'70%',
      data:{
        numero: this.tableOpt[index].celular_grupo,
        telefono: this.tableOpt[index].telefono_grupo,
        radicado: radicado
      }
    });
  }

  /**
   * Abre el modal FuseConfirmDialog, encargado de mostrar un mensaje de confirmación, si el usuario acepta,
   * devuelve una variable verdadera(TRUE), ejecutando el servicio 'QuitarCobroFijo'
   * @param {string} empresa 
   * @param {string} radicado 
   * @param {string} documento 
   */
  public quitarCobroFijo(empresa: string, radicado: string, documento: string): void {
    let modal: any;
    let datos = {
      grunit: documento,
      grugru: radicado,
      database: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft',
      user: JSON.parse(localStorage.getItem('usuario'))['id_usuario']
    }

    modal = this._dialog.open(FuseConfirmDialogComponent, {
      data: {
        mensaje: '¿Seguro que quiere llevar a cabo esa acción?'
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      if(result){
        this._cartera.QuitarCobroFijo(datos.database, datos.grunit, datos.grugru, datos.user).subscribe((data: any) => {
          if(data.changedRows == 1){
            this._snackBar.open('Cobro Fijo Eliminado', 'Aceptar', {
              duration: 2000
            });
            this.busquedaxCiclos(this.ciclo);
          }else{
            this._snackBar.open('Error al eliminar el cobro fijo', '', {
              duration: 2000,
              panelClass: ['warn-600']
            });
          }
        });
      } 
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Modals
  // -----------------------------------------------------------------------------------------------------

  /**
   * Abre modal TotalServicios, encargado de mostrar todos los servicios del grupo en cuestión
   * @param {string} empresa 
   * @param {string} radicado 
   */
  public modalTotalServicios(empresa: string, radicado: string): void {
    this._dialog.open(TotalServiciosGrupoComponent, {
      data: {
        base_datos: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft',
        search_code: radicado
      }
    });
  }

  /**
   * Abre modal BitacoraGrupo, encargado de mostrar la bitácora del grupo en cuestión
   * @param {string} empresa 
   * @param {string} radicado 
   */
  public modalBitacoraGrupo(empresa: string, radicado: string): void {
    this._dialog.open(BitacoraGrupoComponent, {
      data: {
        base_datos: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft',
        search_code: radicado
      }
    });
  }

  /**
   * Abre modal HistoricoFacturas, encargado de mostrar el historico de facturas del grupo
   * @param {string} empresa 
   * @param {string} radicado 
   * @param {string} documento 
   */
  public modalHistoricoFacturas(empresa: string, radicado: string, documento: string): void {
    this._dialog.open(HistoricoFacturasComponent, {
      data: {
        grunit: documento,
        grugru: radicado,
        base_datos: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft'
      }
    });
  }

  /**
   * Abre modal Beneficiarios, encargado de mostrar el historial de beneficiarios 
   * @param {string} grunit 
   * @param {string} grugru 
   */
  public modalBeneficiarios(grunit: string, grugru: string){
    this._dialog.open(BeneficiariosXGrupoComponent, {
      maxWidth: '93vw',
      data: {
        Documento: grunit,
        Radicado: grugru
      }
    });
  }

  /**
   * Abre modal ObservacionCarteraGrupo, encargado de la visualización y modificación de las observaciones del grupo
   * @param {string} radicado 
   * @param {string} documento
   * @param {string} empresa
   */
  public modalObservacionCartera(empresa: string, radicado: string, documento: string){
    this._dialog.open(ObservacionCarteraGrupoComponent, {
      width: '30%',
      height: '70%',
      data: {
        grunit: documento,
        grugru: radicado,
        base_datos: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft'
      }
    });
  }

  /**
   * Abre modal FacturasAtrasadas, encargado de mostrar la cantidad de facturas atrasadas y la información sobre estas
   * @param {string} empresa
   * @param {string} documento
   * @param {string} radicado
   * @param {string} nombre
   * @param {string} atrasos
   */
  public modalFacturasAtrasadas(empresa: string, documento: string, radicado: string, nombre: string, atrasos: string): void {
    this._dialog.open(FacturasAtrasadasComponent, {
      data: {
        base_datos: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft',
        info_grupo : {
          grunit: documento,
          grugru: radicado,
          grunom: nombre,
          cant_atraso: atrasos
        }
      }
    });
  }

  /**
   * Abre modal BitacoraRetiros, encargado de mostrar la cantidad de retiros del grupo, y mostrar su bitácora
   * @param {string} empresa
   * @param {string} radicado 
   * @param {string} documento 
   * @param {string} nombre 
   * @param {string} retiros 
   */
  public modalBitacoraRetiros(empresa: string, radicado: string, documento: string, nombre: string, retiros: string): void {
    this._dialog.open(BitacoraRetirosComponent, {
      data: {
        base_datos: empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft',
        search_code: radicado,
        info_grupo: {
          grunit: documento,
          grugru: radicado,
          grunom: nombre,
          cant_retiro: retiros
        }
      }
    });
  }

  /**
   * Abre modal HistoriaLlamadas, encargado de mostrar el historial de llamada del grupo
   * @param {string} id_grupo
   */
  public modalHistoriaLlamadas(id_grupo: string): void {
    this._dialog.open(LlamadasBitacoraComponent, {
      data: {
        id_grupo: id_grupo
      }
    });
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Disabled Functions: Funciones obsoletas con la nueva versión
  // -----------------------------------------------------------------------------------------------------

  /* public opcionReprogCobro(empresa: string, radicado: string, documento: string, index: number): void {
    const baseDatos: string = empresa === 'VitalMascotas'? 'medisoftvet' : 'medisoft';
    
    
    this._cartera.verUltimoCobro(baseDatos, documento, radicado).subscribe((data: any) => {
      if(data){
        this._dialog.open(VerCobroComponent, {
          width: '63%',
          height: '100%',
          panelClass: 'custom-dialog-container',
          data: {
            grunit: documento,
            data_base: baseDatos,
            grugru: radicado,
            ciclo: this.tableOpt[index].ciclo_grupo,
            estado: this.tableOpt[index].beneficiarios_activos === 0 ? 'Inactivo' : 'Activo',
            nvo_saldo: this.tableOpt[index].saldo_total,
            nombre: this.tableOpt[index].nombre_grupo,
            id_grupo: this.tableOpt[index].ID_Grupo
          }
        });
      }else{
        this._snackBar.open('Cliente sin cobros existentes', 'x', {
          duration: 2000,
          panelClass: 'yellow'
        });
      }
    });
  } */

}
